module.exports = __webpack_public_path__ + "img/mark.5c97ae7b.svg";